// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_qe-0";